export interface RopeLandingPageFilterSettings {
  search: string;
  status: string[];
  client: string[];
  office: string[];
  entity: string[];
  projectCode: string[];
  inactive: boolean;
}

export function defaultRopeLandingPageFilterSettings(): RopeLandingPageFilterSettings {
  return {
    search: "",
    status: [],
    client: [],
    office: [],
    entity: [],
    projectCode: [],
    inactive: false
  };
}
